import { ApiClient } from './ApiClient';
export const DiscountsApi = (instance, httpClient) => {
  const apiClient = new ApiClient(httpClient);
  async function queryDiscounts(Apis) {
    const url = Apis.discounts_query_url;
    console.log('>>> Api url', url);
    const response = await apiClient.performAPIRequest({
      requestPromise: apiClient.post(url, instance),
      context: 'getDiscounts',
      isArr: true
    });
    console.log('>>>> getDiscounts = ', response);
    return response.pagingMetadata.count ? response == null ? void 0 : response.discountRules : [];
  }
  async function queryDiscount(id, Apis) {
    var _response$discountRul;
    const url = `${Apis.discount_query_url}/${id}`;
    const response = await apiClient.performAPIRequest({
      requestPromise: apiClient.get(url, instance),
      context: 'getDiscount'
    });
    console.log('>>>> getDiscount = ', response);
    return response != null && (_response$discountRul = response.discountRule) != null && _response$discountRul.id ? response == null ? void 0 : response.discountRule : {};
  }
  return {
    queryDiscounts,
    queryDiscount
  };
};
//# sourceMappingURL=discountsApi.js.map